import { Component, h, Prop, Element, Method } from '@stencil/core';
import { billingKey, trans } from "../../../../utils/trans";
import { FormRenderProps, FormValues } from "../../../stencil-form/declarations";

import CheckboxField from "../../../stencil-form/CheckboxField";

@Component({
    tag: 'rentware-checkout-billing-template',
    styleUrl: 'style.sass',
    shadow: true,
})
export class RentwareCheckoutBillingTemplate {
    @Prop() initialValues;
    @Prop() locale: string;
    @Prop() translations;
    @Prop() submitBilling;
    @Prop() renderAddressFields;
    @Prop() countriesOptions;
    @Prop() formConfig;
    @Prop() billingFormRef;
    @Prop() onFormValid;
    @Prop() currentStep;
    @Prop() errors;

    @Element() el;

    @Method()
    async goToFirstError() {
        this.goToError();
    }

    onFormSubmit = (e) => {
        e.preventDefault();
        const values = e.detail.values;
        this.submitBilling.emit(values);
    }

    componentDidLoad() {
        if (this.errors?.some(error => error.stepId === this.currentStep.id)) {
            this.goToError();
        }
    }

    goToError = () => {
        this.el.shadowRoot.querySelector(".has-error")?.scrollIntoView({ behavior: 'smooth' });
    }

    formTemplate = (props: FormRenderProps<FormValues>) => {
        const { values } = props;

        return (
            <form class="FieldsContainer">
                <rentware-spacer size="S" />

                {!this.formConfig.shippingAddressSameAsAddress &&
                    <div class="CheckboxContainer">
                        <CheckboxField
                            {...props}
                            label={trans(billingKey('sameShippingAddress'), this.locale, this.translations)}
                            name="hideShipping"
                        />
                    </div>
                }

                <div class="FieldsContainer">
                    {this.renderAddressFields('', this.formConfig.address, props, this.countriesOptions, this.translations, this.locale)}

                    {!values.hideShipping &&
                        <div class="OtherShippingAddress">
                            <rentware-spacer size="XL" />

                            <div class="BillingTitle">
                                {trans(billingKey('shippingTitle'), this.locale, this.translations)}
                            </div>

                            {this.renderAddressFields('shipping', this.formConfig.shippingAddress, props, this.countriesOptions, this.translations, this.locale)}

                            <div class="spacerThree" />
                            <div class="spacerFour" />
                        </div>
                    }
                </div>
            </form>
        )
    }

    render() {
        return (
            <div class="BillingContainer" >
                <div class="BillingContainerInner">
                    <rentware-spacer-m class="MobileOnly" />

                    <div class="BillingTitle">
                        {trans(billingKey('title'), this.locale, this.translations)}
                    </div>

                    <rentware-spacer size="S" />

                    <stencil-form
                        ref={(el) => this.billingFormRef(el)}
                        initialValues={this.initialValues}
                        onFormSubmit={(e) => this.onFormSubmit(e)}
                        validateOnInput={false}
                        onFormValid={this.onFormValid}
                        renderer={this.formTemplate}
                    />

                    <rentware-spacer size="XL" />
                    <rentware-spacer size="XL" />
                </div >
            </div >
        )
    }
}
